<template>
	<div>
		<Header :sel='2' @changePhone="changePhone" />
		<!--neirong-->
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
			<div class="banner">
				<div class="banner_t">{{detail.categoryName}}</div>

			</div>
			<!--banner-->

			<!--neirong-->
			<div class="bread_bg">
				<div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)"
						@click="goMore('/solutionList')">解决方案</a>- <a href="javascript:void(0)"
						@click="goNext2(detail.parentCode,detail.pName)">{{detail.pName}} </a>- <a href="#">{{detail.categoryName}}
					</a></div>
			</div>
			<div class="neirong">
				<div class="fangan_title">{{detail.categoryName}}</div>
				<div class="fangan_bq">产品简介</div>
				<div class="fangan_jianjie" v-html="detail.introduction"></div>
				<div class="fangan_bq">案例推荐</div>
				<ul class="anli_tuijian">
					<li v-for="(item,index) in caseList" :key="index"><a href="javascript:void(0)"
							@click="goNext(item.id)">{{item.clientName}} | {{item.caseName}}</a></li>
				</ul>


			</div>
			<Footer />
		</div>



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		getSolutionDetail,
		getCaseList
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				caseList: []
			}
		},

		mounted() {
			this.id = this.$route.query.id
			this.getNewDetail();
			this.getCaseList()
		},

		methods: {
			// goNext(item){
			// 	this.$router.push({
			// 		path:'caseDetail?id='+item.id,
			// 	})
			// },
			goNext(id) {
				this.$router.push({
					path: '/caseDetail',
					query: {
						id: id
					}
				})
			},
			goNext2(id,name) {
				this.$router.push({
					path: '/solutionList',
					query: {
						id: id,
						name:name
					}
				})
			},
			getCaseList() {
				getCaseList({
					pageNumber: 1,
					pageSize: 10,
					categoryCode: this.id,
					categoryName: ''
				}).then(res => {
					this.caseList = res.data.list

				});
			},
			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				getSolutionDetail({
					id: this.id,
				}).then(res => {
					this.detail = res.data
					document.title = this.detail.categoryName + ' - ' + localStorage.getItem('webTitle')
				});
			},
			goMore(url) {
				this.$router.replace(url)
			},
			

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		background-image: url('../../assets/images/banner_02_2.png');
	}
</style>